import { Injectable } from '@angular/core';
import { AppSettings } from '../shared/App-Settings';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../core/authentication.service';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ResponseDTO } from '../models/response-dto';
import { CustomerFilterOption } from '../searchFilters/CustomerFilterOption';

const apiUrl = AppSettings.API_BASE_URL + "api/";

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private httpClient: HttpClient, private auth: AuthenticationService) { }

  private handleError<T>(operation = 'operation', result?: T) {
    let errorMsg = '';
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getCustomers(currentPage: number, pageSize: number, order: string, sortby: string, filter: CustomerFilterOption): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'CustomersCollection';


    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (filter.customerCode) {
      url = url + '&customerCode=' + btoa(filter.customerCode);
    }
    if (filter.SendTo != null && filter.SendTo != "") {
      url = url + '&SendTo=' + filter.SendTo;
    }
    if (filter.customerId) {
      url = url + '&customerId=' + filter.customerId;
    }
    if (filter.customerIds) {
      url = url + '&customerIds=' + filter.customerIds.toString();
    }
    if (filter.email) {
      url = url + '&email=' + filter.email;
    }
    if (filter.firstName) {
      url = url + '&firstName=' + filter.firstName;
    }
    if (filter.lastName) {
      url = url + '&lastName=' + filter.lastName;
    }
    if (filter.country) {
      url = url + '&country=' + filter.country;
    }
    if (filter.countryId) {
      url = url + '&countryId=' + filter.countryId;
    }
    if (filter.searchKey) {
      url = url + '&SearchKey=' + filter.searchKey;
    }

    return this.httpClient.get<any>(url, httpOptions).pipe(
      tap(heroes => console.log('fetched products')),
      catchError(this.handleError('getPackages', []))
    );
  }


  searchCustomer(searchKey: string, includeUnknownCustomer: boolean = false, currentPage: number, pageSize: number, order: string = 'asc', sortby: string = 'customerCode'): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    //    let url = `${apiUrl}` + 'customerSearchList';
    let url = `${apiUrl}` + 'CustomersCollection';

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (searchKey) {
      url = url + '&SearchKey=' + searchKey;
    }
    if (includeUnknownCustomer) {
      url = url + '&includeUnknownCustomer=' + includeUnknownCustomer;
    }
    return this.httpClient.get<any>(url, httpOptions);
  }

  getCustomerById(id: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    const url = `${apiUrl}` + 'customers/' + `${id}`;

    return this.httpClient.get<any>(url, httpOptions);

  }

  updateCustomerAddress(customerId: number, address: string = null, shippingDetailId: number = null) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    const obj = {
      shippingDetailId: shippingDetailId,
      addressLine1: address
    }

    let url = `${apiUrl}customers/${customerId}/shippingDetails/${shippingDetailId}/updateAddress`;

    return this.httpClient.patch<number>(url, obj, httpOptions);
  }

  getPreAlerts(currentPage: number, pageSize: number, order: string, sortby: string, customerId: number): Observable<ResponseDTO> {

    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'OrdersCollection';

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (customerId > 0)
      url = url + '&CustomerId=' + customerId;

    return this.httpClient.get<any>(url, httpOptions);
  }
  getPreAlert(orderId: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}` + 'Orders/' + orderId;

    return this.httpClient.get<any>(url, httpOptions);
  }

  updateCustomer(id: number, customers) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    const obj = {
      Status: status
    }
    let url = `${apiUrl}customers/` + `${id}`;

    return this.httpClient.put<any>(url, customers, httpOptions);
  }

  updateCustomerStatus(id: number, status: number) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    const obj = {
      Status: status
    }
    let url = `${apiUrl}Customers/` + id + `/UpdateStatus`
    return this.httpClient.patch<any>(url, obj, httpOptions);
  }

  getCustomerNotes(id: number) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}CustomerNotesCollection?customerId=` + id;
    return this.httpClient.get<any>(url, httpOptions);
  }

  updateInstruction(id, instruction) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    const obj = {
      Instructions: instruction
    }
    let url = `${apiUrl}Customers/` + id + `/UpdateInstruction`
    return this.httpClient.patch<any>(url, obj, httpOptions);
  }

  customerLogin(id: number) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}Customers/Login`;
    return this.httpClient.post<any>(url, id, httpOptions);
  }

  verifyCustomer(request) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
      })
    };
    const obj = {
      requestdata: request
    }
    let url = `${apiUrl}Customers/VerifyCustomerLogin`;
    return this.httpClient.post<any>(url, obj, httpOptions);
  }

  addCustomerNote(model, customerId) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    const obj = {
      Note: model,
      CustomerId: customerId
    }

    let url = `${apiUrl}CustomerNotes`;
    return this.httpClient.post<any>(url, obj, httpOptions);
  }
  getCustomerStatusList(): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}` + 'GetCustomerStatusList';

    return this.httpClient.get<any>(url, httpOptions);
  }

  customersGlobalSearch(currentPage: number, pageSize: number, order: string, sortby: string, filter: CustomerFilterOption): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'CustomersCollection/GlobalSearch';


    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (filter.customerCode) {
      url = url + '&customerCode=' + btoa(filter.customerCode);
    }
    if (filter.customerId) {
      url = url + '&customerId=' + filter.customerId;
    }
    if (filter.customerIds) {
      url = url + '&customerIds=' + filter.customerIds.toString();
    }
    if (filter.email) {
      url = url + '&email=' + filter.email;
    }
    if (filter.firstName) {
      url = url + '&firstName=' + filter.firstName;
    }
    if (filter.lastName) {
      url = url + '&lastName=' + filter.lastName;
    }
    if (filter.country) {
      url = url + '&country=' + filter.country;
    }
    if (filter.primaryShippingCountryID) {
      url = url + '&primaryShippingCountryID=' + filter.primaryShippingCountryID;
    }
    if (filter.countryId) {
      url = url + '&countryId=' + filter.countryId;
    }
    if (filter.searchKey) {
      url = url + '&SearchKey=' + filter.searchKey;
    }
    if (filter.IncludeUnknownCustomer) {
      url = url + '&includeUnknownCustomer=' + filter.IncludeUnknownCustomer;
    }

    return this.httpClient.get<any>(url, httpOptions).pipe(
      tap(heroes => console.log('fetched products')),
      catchError(this.handleError('getPackages', []))
    );
  }

  getCustomersCollection(currentPage: number, pageSize: number, order: string, sortby: string, filter: CustomerFilterOption): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'CustomersCollectionSearch';


    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (filter.customerCode) {
      url = url + '&customerCode=' + btoa(filter.customerCode);
    }
    if (filter.customerId) {
      url = url + '&customerId=' + filter.customerId;
    }
    if (filter.customerIds) {
      url = url + '&customerIds=' + filter.customerIds.toString();
    }
    if (filter.email) {
      url = url + '&email=' + filter.email;
    }
    if (filter.firstName) {
      url = url + '&firstName=' + filter.firstName;
    }
    if (filter.lastName) {
      url = url + '&lastName=' + filter.lastName;
    }
    if (filter.country) {
      url = url + '&country=' + filter.country;
    }
    if (filter.countryId) {
      url = url + '&countryId=' + filter.countryId;
    }
    if (filter.searchKey) {
      url = url + '&SearchKey=' + filter.searchKey;
    }

    return this.httpClient.get<any>(url, httpOptions).pipe(
      tap(heroes => console.log('fetched products')),
      catchError(this.handleError('getPackages', []))
    );
  }

  packageCreateSearch(currentPage: number, pageSize: number, order: string, sortby: string, filter: CustomerFilterOption): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'CustomersCollection/PackageCreate';


    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (filter.customerCode) {
      url = url + '&customerCode=' + btoa(filter.customerCode);
    }
    if (filter.customerId) {
      url = url + '&customerId=' + filter.customerId;
    }
    if (filter.customerIds) {
      url = url + '&customerIds=' + filter.customerIds.toString();
    }
    if (filter.email) {
      url = url + '&email=' + filter.email;
    }
    if (filter.firstName) {
      url = url + '&firstName=' + filter.firstName;
    }
    if (filter.lastName) {
      url = url + '&lastName=' + filter.lastName;
    }
    if (filter.country) {
      url = url + '&country=' + filter.country;
    }
    if (filter.countryId) {
      url = url + '&countryId=' + filter.countryId;
    }
    if (filter.searchKey) {
      url = url + '&SearchKey=' + filter.searchKey;
    }
    if (filter.IncludeUnknownCustomer) {
      url = url + '&includeUnknownCustomer=' + filter.IncludeUnknownCustomer;
    }
    if (filter.Status != null) {
      url = url + '&Status=' + filter.Status;
    }
    return this.httpClient.get<any>(url, httpOptions).pipe(
      tap(heroes => console.log('fetched products')),
      catchError(this.handleError('getPackages', []))
    );
  }

}
